import { observer } from "mobx-react";
import _ from "lodash";
import { IModal } from "../../stores";
import { IVoucher, VoucherDiscountType } from "../../stores/voucher/index.d";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";
import { formatDate } from "../../utils/functions";
import logo from "../../resources/images/logo-noshe.jpg";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

interface IPrintedVoucher extends IModal {
  voucher: IVoucher;
}

const PrintedVoucher = observer(
  ({ show, setShowModal, voucher }: IPrintedVoucher) => {
    const [printView, setShowPrintView] = useState(false);
    const voucherRef = useRef(null);
    let onBeforeGetContentResolve = useRef(null);

    const handlePrintClick = useReactToPrint({
      content: () => voucherRef.current,
      onAfterPrint: () => {
        setShowPrintView(false);
      },
      onBeforeGetContent: () => {
        return new Promise((resolve) => {
          setShowPrintView(true);
          resolve(onBeforeGetContentResolve);
        });
      },
    });

    useEffect(() => {
      if (printView && onBeforeGetContentResolve.current) {
        onBeforeGetContentResolve.current = null;
      }
    }, [printView, onBeforeGetContentResolve]);

    return (
      <Modal
        show={show}
        onHide={() => setShowModal(false)}
        className="modal-lg"
      >
        <ModalHeader closeButton>
          <Modal.Title>
            <h5>Printable Voucher</h5>
          </Modal.Title>
        </ModalHeader>
        <ModalBody>
          <div
            className="card border-secondary shadow-sm p-3 d-flex flex-row"
            ref={voucherRef}
          >
            <div className="flex-grow-1 me-3">
              <div className="h6 fw-bold mb-1">
                {voucher.discountType === VoucherDiscountType.Percentage
                  ? voucher.discountValue + "%"
                  : "Flat £" + voucher.discountValue}{" "}
                off
              </div>
              <div className="fw-bold fs-5 mb-1 bg-light p-1 rounded text-center">
                {voucher.voucherCode.toUpperCase()}
              </div>
              <div className="text-muted small">
                Valid until: {formatDate(voucher.endDate, "DD MMM YYYY")}
              </div>
              <div className="text-muted small">* Terms & Conditions apply</div>
            </div>

            <div>
              <img src={logo} alt="Company logo" width={125} />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-default flex-fill"
            onClick={handlePrintClick}
          >
            <FontAwesomeIcon icon={faPrint} className="me-2" />
            <span>Print</span>
          </button>
        </ModalFooter>
      </Modal>
    );
  }
);

export default PrintedVoucher;
